import { render } from "./project-card.vue?vue&type=template&id=7880c9d0&scoped=true"
import script from "./project-card.vue?vue&type=script&lang=js"
export * from "./project-card.vue?vue&type=script&lang=js"

import "./project-card.vue?vue&type=style&index=0&id=7880c9d0&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7880c9d0"]])

export default __exports__